import confirmation from "../../../assets/images/svg/confirmation.svg";
import Button from "../button/button.index";
import { ButtonSize, ButtonType } from "../button/button.interface";
import { ConfirmationModalProps } from "./confirmationModal.interface";
import { useEffect, useRef } from "react";
import Dialog from "../dialog/dialog.index";

export default function ConfirmationModal(props: ConfirmationModalProps): JSX.Element {
    const ButtonRef = useRef<any>();

    useEffect(() => {
        if (ButtonRef.current) ButtonRef.current.focus();
    });

    return (
        <>
            {
                <Dialog
                    status={props.status}
                    onClose={props.onClose}
                    closeOnBlur={props.closeOnBlur !== undefined ? props.closeOnBlur : true}
                    deleteDialog={props.modalType === "DELETE"}
                    clearSelectedFiles={true}
                    closeButton={false}
                >
                    <div
                        className={`flex flex-col items-center p-6 relative`}
                        onKeyDown={(e) => {
                            if (e.key === "Escape") {
                                props.onClose();
                            }
                        }}
                    >
                        {props.modalType === "ACTION" && <img src={confirmation} alt="" />}
                        <p className={`leading-8 ${props.modalType === "ACTION" ? "text-center mt-8" : "w-full mt-2"}`}>{props.text}</p>
                        {props.children}
                        {props.modalType === "DELETE" ? (
                            <div className={`flex w-full ${props.rotateButtons && "flex-row-reverse"} items-center gap-2 mt-8`}>
                                <Button
                                    text={props.submitButtonText}
                                    size={ButtonSize.SM}
                                    className={`w-1/2 outline-none !h-12`}
                                    type={ButtonType.DELETE}
                                    onClick={props.onSubmit}
                                    ref={ButtonRef}
                                    autoFocus={true}
                                />
                                <Button
                                    text={props.cancelButtonText}
                                    size={ButtonSize.SM}
                                    type={ButtonType.CANCEL}
                                    className={`w-1/2 !h-12`}
                                    onClick={props.onClose}
                                    autoFocus={false}
                                />
                            </div>
                        ) : (
                            <div className={`flex w-full ${props.rotateButtons && "flex-row-reverse"} items-center gap-2 mt-8`}>
                                <Button
                                    text={props.submitButtonText}
                                    size={ButtonSize.SM}
                                    className={`w-1/2 outline-none !h-12`}
                                    type={ButtonType.PRIMARY}
                                    onClick={props.onSubmit}
                                    ref={ButtonRef}
                                    autoFocus={true}
                                />
                                <Button
                                    text={props.cancelButtonText}
                                    size={ButtonSize.SM}
                                    type={ButtonType.CANCEL}
                                    className={`w-1/2 !h-12`}
                                    onClick={props.onClose}
                                    autoFocus={false}
                                />
                            </div>
                        )}
                    </div>
                </Dialog>
            }
        </>
    );
}
